<template>
  <van-popup v-model="show" position="bottom" safe-area-inset-bottom :close-on-click-overlay="false">
    <div class="reportDialog">
    <div class="top">
      <div class="title">举报</div>
      <img @click="closePop" src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/icon_close.png">
    </div>
    <div class="content">
      <!--  流式布局的tags    -->
      <div class="tagContainer">
        <div
            class="tagItem"
            :class="{ active: complaintType === item }"
            v-for="(item, index) in types"
            :key="index"
            @click="complaintType = item">
          {{ item }}
        </div>
      </div>
      <!--  输入框区域    -->
      <div class="field">
        <van-field
            v-model="complaintContent"
            rows="2"
            :autosize="autosize"
            maxlength="200"
            show-word-limit
            type="textarea"
            placeholder="我们想知道你举报的原因，你可以描述你遇到的问题。"
        />
      </div>
      <!--   按钮    -->
      <div class="btn"
           :class="{ active: isSubmitButtonActive }" @click="addComplaint">
        提交
      </div>
    </div>
    <transition name="fade">
      <loading v-show="loading"></loading>
    </transition>
    </div>
  </van-popup>
</template>

<script>
import * as Http from "@/api/HttpService";

export default {
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: Boolean,
    ai_app_code: {
      type: String,
      default:'',
    },
  },
  data() {
    return {
      //举报的类型
      types: [],
      //反馈的信息
      complaintContent:"",
      //提交的举报tag
      complaintType:"",
      autosize:{ maxHeight: 84, minHeight: 84 },
      loading:false,
    };
  },
  computed: {
    isSubmitButtonActive() {
      return this.complaintContent.trim() !== "" && this.complaintType !== "";
    },
  },
  mounted() {
    this.getComplaintTypes()
  },
  methods:{
    // 获取举报类型
    getComplaintTypes: async function () {
      this.loading = true;
      await Http.complaintTypes({})
          .then(({ res }) => {
            if (res.code == "SUCCESS") {
              this.types = res.originalData.data
            }
          })
          .catch((err) => {
            console.log(err);
          });
      this.loading = false;
    },
    //举报
    addComplaint: async function () {
      if (!this.isSubmitButtonActive){
        if (this.complaintType == ""){
          this.$toast("请选择举报类型")
          return
        }
        if (this.complaintContent.trim() == ""){
          this.$toast("请填写举报原因")
          return
        }
      }
      this.loading = true;
      let params = {
        complaintType:this.complaintType,
        complaintContent:this.complaintContent,
        ai_app_code:this.ai_app_code,
      }
      await Http.complaintAdd(params)
          .then(({ res }) => {
            console.log("==",res);
            if (res.code == "SUCCESS") {
              this.closePop();
              this.$toast("举报已提交")
            }else{
              this.$toast(res.originalData.msg || "提交失败");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      this.loading = false;
    },
    //关闭pop
    closePop(){
      this.$emit("change", false);
    },
  }
};
</script>

<style scoped lang="scss">
@import "ReportDialog";
</style>
